import { memo } from 'react';

import {
  WorkspaceAgentFieldInput,
  type WorkspaceAgentFieldSpec,
} from '~/components/v2/components/workspace/workspace-agent-panel/components/consent/form/WorkspaceAgentFieldInput';

export type WorkspaceAgentFieldsControlProps = {
  fields: readonly WorkspaceAgentFieldSpec[];
  onChange: (label: string, value: string) => void;
  values: Readonly<Record<string, string>>;
};

export const WorkspaceAgentFieldsControl = memo(({ fields, onChange, values }: WorkspaceAgentFieldsControlProps) => (
  <div className="flex flex-col gap-2">
    {fields.map((field) => (
      <WorkspaceAgentFieldInput field={field} key={field.label} onChange={onChange} value={values[field.label] ?? ''} />
    ))}
  </div>
));

WorkspaceAgentFieldsControl.displayName = 'WorkspaceAgentFieldsControl';
